import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import logo from './logo.png';

function Navbar(props) {
    const { isSmallDevice, toggleLogo } = props;
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleMenuToggle = () => {
      setIsMenuOpen(!isMenuOpen);
    }

    let list1 = (
        <ul className="navbar-list">
          <li className="navbar-dropdown">
            <HashLink smooth to="/#" className="navbar-link" onClick={handleMenuToggle}>
              HOME
            </HashLink>
            <ul className={`navbar-sublist ${isSmallDevice ? 'navbar-accordion' : ''}`}>
              <li className="navbar-subitem">
                <HashLink smooth to="/#about" className="navbar-link" onClick={handleMenuToggle}>
                  ABOUT
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink smooth to="/#get-involved" className="navbar-link" onClick={handleMenuToggle}>
                  GET INVOLVED
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink smooth to="/#events" className="navbar-link" onClick={handleMenuToggle}>
                  EVENTS
                </HashLink>
              </li>
            </ul>
          </li>

          <li className="navbar-dropdown">
            <HashLink smooth to="/#pillars" className="navbar-link" onClick={handleMenuToggle}>
              PILLARS
            </HashLink>
            <ul className={`navbar-sublist ${isSmallDevice ? 'navbar-accordion' : ''}`}>
              <li className="navbar-subitem">
                <HashLink smooth to="/dance#" className="navbar-link" onClick={handleMenuToggle}>
                  DANCE
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink smooth to="/culture#" className="navbar-link" onClick={handleMenuToggle}>
                  CULTURE
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink smooth to="/sports#" className="navbar-link" onClick={handleMenuToggle}>
                  SPORTS
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink smooth to="/philanthropy#" className="navbar-link" onClick={handleMenuToggle}>
                  PHILANTHROPY
                </HashLink>
              </li>
            </ul>
          </li>

          <li className="navbar-dropdown">
            <HashLink smooth to="/#programs" className="navbar-link" onClick={handleMenuToggle}>
              PROGRAMS
            </HashLink>
            <ul className={`navbar-sublist ${isSmallDevice ? 'navbar-accordion' : ''}`}>
              <li className="navbar-subitem">
                <HashLink to="/aka#" className="navbar-link" onClick={handleMenuToggle}>
                  AKA / RAKA
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink to="/maffia#" className="navbar-link" onClick={handleMenuToggle}>
                  MAFFIA
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink to="/fsa+#" className="navbar-link" onClick={handleMenuToggle}>
                  FSA+
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink to="/web-interns#" className="navbar-link" onClick={handleMenuToggle}>
                  WEB INTERNS
                </HashLink>
              </li>
            </ul>
          </li>
        </ul>
      );
    
      let list2 = (
        <ul className="navbar-list">
          <li className="navbar-dropdown">
            <HashLink smooth to="/leadership#" className="navbar-link" onClick={handleMenuToggle}>
              LEADERSHIP
            </HashLink>
            <ul className={`navbar-sublist ${isSmallDevice ? 'navbar-accordion' : ''}`}>
              <li className="navbar-subitem">
                <HashLink smooth to="/leadership#eboard" className="navbar-link" onClick={handleMenuToggle}>
                  EXECUTIVE BOARD
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink smooth to="/leadership#cboard" className="navbar-link" onClick={handleMenuToggle}>
                  CHAIR BOARD
                </HashLink>
              </li>
              {/* <li className="navbar-subitem">
                <HashLink smooth to="/leadership#committees" className="navbar-link" onClick={handleMenuToggle}>
                  EVENT COMMITTEES
                </HashLink>
              </li> */}
            </ul>
          </li>
          <li className="navbar-dropdown">
            <HashLink to="/media#" className="navbar-link" onClick={handleMenuToggle}>
              MEDIA
            </HashLink>
            <ul className={`navbar-sublist ${isSmallDevice ? 'navbar-accordion' : ''}`}>
              <li className="navbar-subitem">
                <HashLink smooth to="/media#barkada" className="navbar-link" onClick={handleMenuToggle}>
                  BARKADA NEWSLETTER
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink smooth to="/media#podcast" className="navbar-link" onClick={handleMenuToggle}>
                  PROJECT LUNCHBOX
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink smooth to="/media#archive" className="navbar-link" onClick={handleMenuToggle}>
                  ARCHIVE
                </HashLink>
              </li>
            </ul>
          </li>

          <li className="navbar-dropdown">
            <HashLink to="/shop#" className="navbar-link" onClick={handleMenuToggle}>
              SHOP
            </HashLink>
            <ul className={`navbar-sublist ${isSmallDevice ? 'navbar-accordion' : ''}`}>
              <li className="navbar-subitem">
                <HashLink smooth to="/shop#fundraising" className="navbar-link" onClick={handleMenuToggle}>
                  FUNDRAISING EVENTS
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink smooth to="/shop#apparel" className="navbar-link" onClick={handleMenuToggle}>
                  APPAREL
                </HashLink>
              </li>
              <li className="navbar-subitem">
                <HashLink smooth to="/shop#philanthropy" className="navbar-link" onClick={handleMenuToggle}>
                  THREADS OF HOPE
                </HashLink>
              </li>
            </ul>
          </li>
          
        </ul>
      );

      let logoWidth = toggleLogo ? 6 : 3;
      let navbar;

      if (isSmallDevice) {
        navbar = (
            <nav className="navbar">
                <div className="navbar-logo">
                    <HashLink smooth to="/#">
                        <img src={logo} id="logo" alt="Logo" style={{ width: '3rem' }} />
                    </HashLink>
                </div>

                <div className="navbar-menu-toggle" onClick={handleMenuToggle}>
                  <div className={`navbar-menu-icon ${isMenuOpen ? 'active' : ''}`} />
                </div>

                <ul className={`navbar-list ${isMenuOpen ? 'active' : ''}`} id="linkList">
                  {list1.props.children}
                  {list2.props.children}
                  <li className="navbar-login-item">
                    <HashLink to="/login" className="navbar-login-button" onClick={handleMenuToggle}>
                      Login
                    </HashLink>
                  </li>
                </ul>
            </nav>
        );
      }
      else {
        navbar = (
            <nav className="navbar">
                <div className="navbar-left">
                    {list1}
                </div>
                <div className="navbar-logo">
                  <HashLink smooth to="/#">
                      <img src={logo} id="logo" alt="Logo" style={{ width: `${logoWidth}rem` }} />
                  </HashLink>
                </div>
                <div className="navbar-right">
                    {list2}
                    <HashLink to="/login" className="navbar-login-button">
                      Login
                    </HashLink>
                </div>
            </nav>
        );
      }

    return (
      <>
        {navbar}
      </>
    );
}

export default Navbar;